import { BaseHttpService } from './base-http.service';
import { URLS } from '../shared/url';
import { ResponseTypeEnum } from '../models/enums';
import * as i0 from "@angular/core";
import * as i1 from "./base-http.service";
var RatingService = /** @class */ (function () {
    function RatingService(http) {
        var _this = this;
        this.http = http;
        this.getRatingList = function () {
            return _this.http.Get(URLS.getRatingList);
        };
        this.getRating = function (ratingId) {
            return _this.http.Get(URLS.getRating + "/" + ratingId);
        };
        this.saveRating = function (rating) {
            return _this.http.Post(URLS.saveRating, rating, ResponseTypeEnum.Success);
        };
        this.deleteRating = function (ratingId) {
            return _this.http.Delete(URLS.deleteRating + "/" + ratingId, ResponseTypeEnum.Success);
        };
    }
    RatingService.ngInjectableDef = i0.defineInjectable({ factory: function RatingService_Factory() { return new RatingService(i0.inject(i1.BaseHttpService)); }, token: RatingService, providedIn: "root" });
    return RatingService;
}());
export { RatingService };
